import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    vendedores: [],
    /* Info de paginación */
    paginaActual: 1,
    totalPaginas: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,

    nombre: '',
    incluirInactivos: false,
    // nombreBusqueda: '',
    
    list: [],
    selectList: [],

    rpt: [],
    resumenComisionesVendedor: {},
    resumenComisionesCobrosVendedor: {}
};

const mutations = {
    updateField,
    
    'INICIALIZAR_OPCIONES'(state) {
        state.vendedores = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR' (state) {
        state.vendedores = [];
    },
    'SET_VENDEDORES' (state, vendedores) {
        state.vendedores = vendedores;
    },
    'SET_PAGINATION' (state, params) {
        state.paginaActual = params.paginaActual;
        state.totalPaginas = params.totalPaginas;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(vendedor => vendedor.nombre.toUpperCase().trim());
    },

    'INICIALIZAR_RPT'(state) {
        state.rpt = [];
    },
    'SET_RPT'(state, rpt) {
        state.rpt = rpt;
        // state.rpt = rpt.map(vendedorComision => ({
        //     ...vendedorComision,
        //     saldo: roundToTwo(vendedorComision.totalComision - vendedorComision.totalCompras)
        // }));
    },
    'INICIALIZAR_RESUMEN'(state) {
        state.resumenComisionesVendedor = {};
    },
    'SET_RESUMEN'(state, resumenComisionesVendedor) {
        state.resumenComisionesVendedor = resumenComisionesVendedor;
    },
    'INICIALIZAR_RESUMEN_COBROS'(state) {
        state.resumenComisionesCobrosVendedor = {};
    },
    'SET_RESUMEN_COBROS'(state, resumenComisionesCobrosVendedor) {
        state.resumenComisionesCobrosVendedor = resumenComisionesCobrosVendedor;
    },
};

function roundToTwo(num) {    
    return +(Math.round(num + 'e+2')  + 'e-2');
}

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getVendedores: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit ('INICIALIZAR');
            
            let queryString = '';
            
            if (state.nombre) {
                if (queryString == '') {
                    queryString = '?nombre=' + state.nombre;
                } else {
                    queryString += '&nombre=' + state.nombre;
                }
            }
            
            if ((/true/i).test(state.incluirInactivos)) {
                if (queryString == '') {
                    queryString += '?incluirInactivos=true';
                } else {
                    queryString += '&incluirInactivos=true';
                }
            }

            apiAxios.get('vendedores' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params= {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages
                        }
                        commit ('SET_PAGINATION', params);
                    }

                    commit ('SET_VENDEDORES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getList: ({ commit }) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            apiAxios.get('vendedores/list')
                .then(res => {
                    commit('SET_LIST', res.data);

                    resolve()
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResumenComisionesVendedor ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESUMEN');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD')
                + '&vendedorId=' + params.vendedorId;
            
            if (params.clienteId != 0) {
                queryString += '&clienteId=' + params.clienteId;
            }

            if (params.soloComprobantesCobrados) {
                queryString += '&soloComprobantesCobrados=true';
            }

            apiAxios.get('vendedores/comisiones/resumen' + queryString)
                .then(res => {
                    commit('SET_RESUMEN', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    }, 
    getResumenPresupuestos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            if ((/true/i).test(params.comisionesInternas)) {
                queryString += '&comisionesInternas=true';
            }

            if (params.vendedorId != 0) {
                queryString += '&vendedorId=' + params.vendedorId;
            }
                
            if (params.clienteId != 0) {
                queryString += '&clienteId=' + params.clienteId;
            }

            apiAxios.get('vendedores/comisiones/presupuestos' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResumenComisionesCobrosVendedor ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESUMEN_COBROS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD')
                + '&vendedorId=' + params.vendedorId;
            
            if (params.clienteId != 0) {
                queryString += '&clienteId=' + params.clienteId;
            }

            apiAxios.get('vendedores/comisiones/cobros/resumen' + queryString)
                .then(res => {
                    commit('SET_RESUMEN_COBROS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },     
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
    rpt (state) {
        return state.rpt;
    },
    resumenComisionesVendedor (state) {
        return state.resumenComisionesVendedor;
    },
    resumenComisionesCobrosVendedor (state) {
        return state.resumenComisionesCobrosVendedor;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}